if (!customElements.get('buy-it-now-button')) {
  customElements.define(
    'buy-it-now-button',
    class BuyItNowButton extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        const form = this.closest('form');
        if (!form) return;

        const buyNowButton = form.querySelector('[id^="BuyItNow-"]');
        if (!buyNowButton) return;

        buyNowButton.addEventListener('click', this.handleBuyNow.bind(this, form, buyNowButton));
      }

      async handleBuyNow(form, button) {
        if (button.hasAttribute('disabled')) return;
        
        button.setAttribute('disabled', 'disabled');
        button.classList.add('loading');
        
        const formData = new FormData(form);
        const variantId = formData.get('id');
        const quantityInput = form.querySelector('input[name="quantity"]');
        const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : (formData.get('quantity') || 1);

        try {
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              items: [{
                id: variantId,
                quantity: parseInt(quantity)
              }]
            })
          });

          if (!response.ok) {
            throw new Error('Error adding to cart');
          }

          const data = await response.json();
          
          window.location.href = window.Shopify.routes.root + 'checkout';
          
        } catch (error) {
          console.error('Buy It Now Error:', error);
          
          button.removeAttribute('disabled');
          button.classList.remove('loading');
        }
      }
    }
  );
}

document.addEventListener('DOMContentLoaded', function() {
  const forms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
  
  forms.forEach(form => {
    const buyNowButton = form.querySelector('[id^="BuyItNow-"]');
    if (buyNowButton && !form.querySelector('buy-it-now-button')) {
      const wrapper = document.createElement('buy-it-now-button');
      form.parentNode.insertBefore(wrapper, form);
      wrapper.appendChild(form);
    }
  });
});

document.addEventListener('click', function(e) {
  if (e.target.closest('[id^="BuyItNow-"]')) {
    const button = e.target.closest('[id^="BuyItNow-"]');
    const form = button.closest('form');
    
    if (!form || button.hasAttribute('disabled')) return;
    
    e.preventDefault();
    button.setAttribute('disabled', 'disabled');
    button.classList.add('loading');
    
    const formData = new FormData(form);
    const variantId = formData.get('id');
    const quantityInput = form.querySelector('input[name="quantity"]');
    const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : (formData.get('quantity') || 1);
    
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: parseInt(quantity)
        }]
      })
    })
    .then(response => {
      if (!response.ok) throw new Error('Error');
      return response.json();
    })
    .then(data => {
      window.location.href = window.Shopify.routes.root + 'checkout';
    })
    .catch(error => {
      console.error('Error:', error);
      button.removeAttribute('disabled');
      button.classList.remove('loading');
    });
  }
});
